// extracted by mini-css-extract-plugin
export default {"input":"integer_input_input__uS56H","toggleIcon":"integer_input_toggleIcon__sBijJ","label":"integer_input_label__G3SgI","container":"integer_input_container__YP9fe"};